import { render, staticRenderFns } from "./InputTaxRateAdd.vue?vue&type=template&id=c7823ade&scoped=true&"
import script from "./InputTaxRateAdd.vue?vue&type=script&lang=js&"
export * from "./InputTaxRateAdd.vue?vue&type=script&lang=js&"
import style0 from "./InputTaxRateAdd.vue?vue&type=style&index=0&id=c7823ade&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7823ade",
  null
  
)

export default component.exports